module.exports = __webpack_public_path__ + "static/media/1_philosophie.2b8ad5fb.jpg";